module.exports = __webpack_public_path__ + "img/des2.dee68a86.jpg";